import API from "@/API";

export default {

    namespaced: true,

    state(){
        return {
            repositories: {},
        };
    },

    getters: {

    },


    mutations: {

        setRepository(state, {scope, fragments, listener}){

            const keys = Object.keys(fragments);
            const timestamps = {};
            const values = {};
            keys.map(k => (timestamps[k] = fragments[k]?.timestamp ?? 0, values[k] = fragments[k].value));

            state.repositories[ repositoryName(scope) ] = {
                scope,
                fragments: values,
                timestamps,
                listener,
            };
        },

        unsetRepository(state, {scope}){
            state.repositories[ repositoryName(scope) ] = undefined;
            delete state.repositories[ repositoryName(scope) ];
        },

        /**
         *
         * @param state
         * @param scope
         * @param fragments FORMAT: {timestamp: 99999999, value: 'xxxxxxxxxx'}
         */
        updateRepository(state, {scope, fragments}){

            const repo_name = repositoryName(scope);
            const repo = state.repositories[ repo_name ];
            const keys = Object.keys(fragments);

            for (let i = 0; i < keys.length; i++){
                const key = keys[ i ];

                if( repo.timestamps[ key ] && fragments[ key ].timestamp ){
                    if( fragments[ key ].timestamp > repo.timestamps[ key ] ){
                        if( fragments[ key ].value ){
                            repo.fragments[ key ] = fragments[ key ].value;
                            repo.timestamps[ key ] = fragments[ key ].timestamp;
                        }
                    }
                }else{
                    if( typeof fragments[ key ].value !== 'undefined' ){
                        repo.fragments[ key ] = fragments[ key ].value;
                        repo.timestamps[ key ] = fragments[ key ].timestamp;
                    }
                }
            }

        },
    },


    actions: {

        /**
         * Get a repository
         * @param state
         * @param commit
         * @param {name: <String>, id: <Number>} scope
         * @returns {Promise<*>}
         */
        async getRepository({state, commit}, scope) {

            const repoName = repositoryName(scope);

            if( typeof state.repositories[ repoName ] === "undefined" ){

                /**
                 * Get the repository data and parse it appropriately.
                 */

                const data = (await API.fragments.getByScope(scope)).data;
                const fragments = {};

                data.map(f => fragments[ f.type ] = {
                    timestamp: Date.parse(f.updated_at),
                    value: f.data
                });

                /**
                 * Start the listening for any realtime changes and store channel &
                 * handler within the repository.
                 */

                const handler = ((data) => {
                    const fragments = {};
                    fragments[ data.fragment.type ] = {
                        timestamp: Date.parse(data.fragment.updated_at),
                        value: data.fragment.data
                    };
                    commit('updateRepository', {scope, fragments});
                });


                const channel = Echo.private( repoName )
                    .listen('.fragment.created',  handler)
                    .listen('.fragment.updated',  handler);


                /**
                 * Commit the data & listener into the repository pool.
                 */

                commit('setRepository', {scope, fragments, listener: {channel, handler}});


            }

            return state.repositories[repositoryName(scope)];
        },


        /**
         * Get a repository
         * @param state
         * @param commit
         * @param {name: <String>, id: <Number>} scope
         * @param object fragments
         * @returns {Promise<*>}
         */
        async updateRepository({commit}, {scope, fragments}) {
            commit('updateRepository', {scope, fragments});
            return (await API.fragments.push(scope, fragments)).data;
        },


        freeRepository({commit}, scope) {
            commit('unsetRepository', {scope});
        },

    },


}


export function repositoryName(scope){
    return [scope.name.split('\\').join('.'), scope.id].join('.');
}
